import { HttpClient } from "@angular/common/http";
import { inject, Injectable, signal } from "@angular/core";
import { environment } from "../../environments/environment";
import { Cls_StudentData } from "../models/master";
import { Subject, Subscription } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class GlobalService {
  private api = environment.API_URL;
  private http = inject(HttpClient);
  LocalAPI = "http://192.168.27.59:4003/api";

  permission = signal<string[]>([]);

  getStudentList() {
    return this.http.get<any>(`${this.api}/student`);
  }
  _isShow = signal<boolean>(true);
  _isLoggedIn = signal<boolean>(true);
  private studentData: Cls_StudentData | null = null;
  private isUpdateOperation = false;

  // Call this from your form to store the data before navigating
  setStudentPayload(data: Cls_StudentData, isUpdate: boolean) {
    this.studentData = data;
    this.isUpdateOperation = isUpdate;
  }

  // Call this from the finance page to retrieve the data
  getStudentPayload(): { data: Cls_StudentData | null; isUpdate: boolean } {
    return { data: this.studentData, isUpdate: this.isUpdateOperation };
  }

  // Call this after the final submission to prevent stale data
  clearStudentPayload() {
    this.studentData = null;
    this.isUpdateOperation = false;
  }

  IsShow() {
    return this._isShow();
  }

  IsLoggedIn() {
    return this._isLoggedIn();
  }

  setIsShowFalse() {
    this._isShow.set(false);
  }

  setIsShowTrue() {
    this._isShow.set(true);
  }

  setIsLoggedInTrue() {
    this._isLoggedIn.set(true);
  }

  setIsLoggedInFalse() {
    this._isLoggedIn.set(false);
  }

  // global.service.ts
  generateOTP(mobileNo: string) {
    return this.http.post<any>(`${this.api}/auth/otp/generate`, { mobileNo });
  }

  onLogin(mobileNo: string, otp: string) {
    // Get device information from the browser
    const deviceInfo = {
      userAgent: window.navigator.userAgent,
      platform: window.navigator.platform,
      appName: window.navigator.appName,
      appVersion: window.navigator.appVersion,
      language: window.navigator.language,
      languages: window.navigator.languages,
      deviceMemory: (window.navigator as any).deviceMemory,
      hardwareConcurrency: (window.navigator as any).hardwareConcurrency,
      screen: {
        width: window.screen.width,
        height: window.screen.height,
        colorDepth: window.screen.colorDepth,
        pixelDepth: window.screen.pixelDepth,
      },
    };

    return this.http.post<any>(`${this.api}/auth/login`, {
      UserMobile: mobileNo,
      otp,
      deviceInfo, // Include the device information
    });
  }

  onLogout() {
    const header = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("Token")}`,
      },
    };
    return this.http.post<any>(`${this.api}/auth/logout`, {}, header);
  }

  SetDefaultMenuCondition(menuList: any[]) {
    menuList.map(data => {
      data.canAdd = false;
      data.canEdit = false;
      data.canDelete = false;
      return data;
    });
  }
  menuSetter(menuList: any[]) {
    menuList = menuList.sort((a: any, b: any) => a.MenuID - b.MenuID);
    menuList = menuList.map((item: any) => {
      if (!item.ParentMenuID) item.ParentMenuID = null;
      return item;
    });
    menuList.map(data => {
      data.ChildList = [];
      data.IsExpanded = false;
      data.IsSelected = false;
      return data;
    });
    const selectedMenu = this.generateNestedStructure(menuList);
    this.sortMenuByOrder(selectedMenu);
    return selectedMenu;
  }

  sortMenuByOrder(menuList: any[]) {
    if (menuList?.length > 0) {
      menuList.sort((a: any, b: any) => {
        return a.iOrder - b.iOrder;
      });
      for (let i = 0; i < menuList?.length; i++) {
        const { ChildList } = menuList[i];
        this.sortMenuByOrder(ChildList);
      }
    }
  }

  generateNestedStructure(data: any[], ParentMenuID = null) {
    const result = [];
    for (const item of data) {
      if (item.ParentMenuID == ParentMenuID) {
        const ChildList = this.generateNestedStructure(data, item.MenuID);

        if (ChildList?.length > 0) {
          item.ChildList = ChildList;
        }

        result.push(item);
      }
    }
    return result;
  }

  reformatMenu(menuList: any[]): any[] {
    if (!Array.isArray(menuList)) {
      console.warn("Invalid menuList provided to reformatMenu:", menuList);
      return [];
    }

    const menuMaster = JSON.parse(JSON.stringify(menuList));
    const selectedMenu = [];

    (function reFormat(ChildList: any[]) {
      for (let index = 0; index < ChildList?.length; index++) {
        const element = ChildList[index];

        if (!element) continue;

        const hasPermission = element.canAdd || element.canEdit || element.canDelete || element.canView;

        if (hasPermission) {
          selectedMenu.push({
            MenuID: element.MenuID,
            CanAdd: !!element.canAdd,
            CanEdit: !!element.canEdit,
            CanDelete: !!element.canDelete,
            CanView: !!element.canView,
          });
        }

        if (Array.isArray(element.ChildList) && element.ChildList.length) {
          reFormat(element.ChildList);
        }
      }
    })(menuMaster);

    return selectedMenu;
  }

  setupDebouncedSearch(subject: Subject<string>, callback: (value: string) => void, delay: number = 500): Subscription {
    return subject.pipe(debounceTime(delay), distinctUntilChanged()).subscribe(callback);
  }
}
